module.exports = __webpack_public_path__ + "static/media/dmn-logo-anim.b5000788.mp4";